import styled from 'styled-components/macro';
import { colors } from '../../../styles/variables';

export const Container = styled.h1`
  color: ${colors.gray_6};
  font-size: 1.8rem;
  margin-top: 72px;
  padding: 2em;
  text-align: center;
  word-break: break-word;
`;
